/* src/app/components/local-agent-approvals/local-agent-approvals.component.scss */
:host {
  display: block;
}
.approval {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 16px;
  background: var(--background-color-secondary, var(--background-color));
  border-bottom: 1px solid var(--border-color, rgba(128, 128, 128, 0.25));
}
.approval-critical {
  border-left: 3px solid var(--color-danger, #d64545);
}
.approval-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.approval-title {
  font-weight: 600;
  color: var(--text-color);
}
.approval-description {
  font-size: 0.85rem;
  color: var(--text-color-secondary, var(--text-color));
  overflow-wrap: anywhere;
}
.approval-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.approval-button {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid var(--color-accent);
  background: var(--color-accent);
  color: var(--color-accent-contrast, #fff);
  font-size: 0.85rem;
  cursor: pointer;
}
.approval-button:disabled {
  opacity: 0.5;
  cursor: default;
}
.approval-button-deny {
  background: transparent;
  color: var(--text-color);
  border-color: var(--border-color, rgba(128, 128, 128, 0.4));
}
/*# sourceMappingURL=local-agent-approvals.component-C6NHV57O.css.map */
